import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["textContent"]

import Icon from "../Icon/Icon.vue";
import Button from "./Button.vue";

interface Props {
  title: string;
  loading?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LoadingButton',
  props: {
    title: {},
    loading: { type: Boolean }
  },
  emits: ['click'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

function click(): void {
  if (!props.loading) {
    emit('click');
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Button, {
    primary: "",
    class: "relative",
    disabled: props.loading,
    "cursor-wait": props.loading,
    onClick: click
  }, {
    default: _withCtx(() => [
      (props.loading)
        ? (_openBlock(), _createBlock(Icon, {
            key: 0,
            name: "buttonLoading",
            class: "spin absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
          }))
        : _createCommentVNode("v-if", true),
      _createElementVNode("span", {
        textContent: _toDisplayString(props.title),
        class: _normalizeClass({invisible: props.loading})
      }, null, 10 /* CLASS, PROPS */, _hoisted_1)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["disabled", "cursor-wait"]))
}
}

})